module.exports = __webpack_public_path__ + "img/dt.8095959b.png";